/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} To_Xml_Pit2_DInputs */

const en_to_xml_pit2_d = /** @type {(inputs: To_Xml_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`If the consumer expects an id as an attribute rather than a child element, this output will not satisfy it. There is no convention in JSON for marking a key as an attribute, so the converter cannot infer the intent. Edit the output by hand for a small document, or use a schema driven serializer for anything larger.`)
};

const ko_to_xml_pit2_d = /** @type {(inputs: To_Xml_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`소비자가 id를 자식 요소가 아니라 속성으로 기대한다면 이 출력은 만족시키지 못합니다. JSON에는 키를 속성으로 표시하는 관례가 없으므로 변환기가 의도를 추론할 수 없습니다. 작은 문서라면 출력을 직접 고치고, 그보다 크면 스키마 기반 직렬화기를 쓰세요.`)
};

const ja_to_xml_pit2_d = /** @type {(inputs: To_Xml_Pit2_DInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`利用側が id を子要素ではなく属性として期待している場合、この出力は満たしません。JSON にはキーを属性として印す慣習がないので、変換器は意図を推論できません。小さな文書なら出力を手で直し、それより大きいならスキーマ駆動のシリアライザを使ってください。`)
};

/**
* | output |
* | --- |
* | "If the consumer expects an id as an attribute rather than a child element, this output will not satisfy it. There is no convention in JSON for marking a key ..." |
*
* @param {To_Xml_Pit2_DInputs} inputs
* @param {{ locale?: "en" | "ko" | "ja" }} options
* @returns {LocalizedString}
*/
export const to_xml_pit2_d = /** @type {((inputs?: To_Xml_Pit2_DInputs, options?: { locale?: "en" | "ko" | "ja" }) => LocalizedString) & import('../runtime.js').MessageMetadata<To_Xml_Pit2_DInputs, { locale?: "en" | "ko" | "ja" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_to_xml_pit2_d(inputs)
	if (locale === "ko") return ko_to_xml_pit2_d(inputs)
	return ja_to_xml_pit2_d(inputs)
});